const Stepper = {
  baseStyle: {
    stepper: {},
    step: {},
    title: {
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '-0.084px',
      color: '#525866',
      borderBottomWidth: '2px',
      borderColor: '#CBCED4',
      '&[data-status=active]': {
        color: '#0A0D14',
        borderColor: '#61A318'
      }
    },
    description: {},
    indicator: {
      h: '24px',
      w: '24px',
      borderColor: '#CBCED4',
      bgColor: 'white',
      '&[data-status=active]': {
        borderColor: '#61A318',
        bgColor: '#61A318',
        color: 'white'
      },
      '&[data-status=complete]': {
        borderColor: '#CDD0D5',
        bgColor: '#CDD0D5',
        color: 'white'
      }
    },
    separator: {
      '&[data-orientation=horizontal]': {
        w: '20px',
        h: '20px',
        color: '#868C98',
        bg: 'none'
      }
    },
    icon: {},
    number: {
      fontSize: '12px',
      fontWeight: 500,
    }
  },
  variants: {
    
  },
  sizes: {
    md: {
      stepper: {
        
      }
    }
  },
  defaultProps: {
    
  }
};

export default Stepper;